import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { permissions } from "../../../store/permissions/actions";
export var useGetPermission = function (trigger, page, limit, search) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePermission: (_a = state.Permission.responsePermission) === null || _a === void 0 ? void 0 : _a.data,
            errorPermission: state.Permission.errorPermission,
            loadingPermission: state.Permission.loadingPermission,
        });
    }), responsePermission = _a.responsePermission, errorPermission = _a.errorPermission, loadingPermission = _a.loadingPermission;
    useEffect(function () {
        if (trigger) {
            dispatch(permissions({
                search: search,
                orderDir: "DESC",
                enable: true,
                page: page,
                limit: limit,
            }));
        }
    }, [trigger]);
    return {
        responsePermission: responsePermission,
        errorPermission: errorPermission,
        loadingPermission: loadingPermission,
    };
};
